import { FileUploadInput } from "../../../components/forms/inputs/FileUploadInput";

export const ProductImageForm = () => {
  return <FileUploadInput multiple={false} />;
};
